"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BaseConfig_1 = require("../BaseConfig");
const Environment_1 = require("../../models/Environment");
const delosConfig = {
    env: Environment_1.BuildEnvironment.Delos,
    ariaCollectorUri: "https://collector.sovcloud-api.de/Collector/3.0/",
    OneDsCollectorUri: "https://collector.sovcloud-api.de/OneCollector/1.0/",
    publicPath: "https://teams.sovcloud-static.de",
    telemetry: {
        tenantToken: "89e4576baa7344839592e639fb3db0f2-48bbdeca-a594-44f3-86e3-78c19c121c06-7126",
    },
    urls: Object.assign(Object.assign({}, BaseConfig_1.default.urls), { absoluteUrls: Object.assign(Object.assign({}, BaseConfig_1.default.urls.absoluteUrls), { brandingService: "https://middletier.teams.sovcloud.de/beta/meetings/branding", brandingWithMeetingidService: "https://middletier.teams.sovcloud.de/beta/meetings/brandinginfo" }) }),
    ecs: Object.assign(Object.assign({}, BaseConfig_1.default.ecs), { host: "https://c2s.config.ecs.svc.sovcloud.de" }),
};
exports.default = delosConfig;
